import FixScroll from '../helpers/FixScroll'

class Menu {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
    this.updateHeaderHeight()
  }

  bindUI() {
    this.body = document.body
    this.mqMax = window.matchMedia( "(max-width: 1024px)" )
    this.mqMin = window.matchMedia( "(min-width: 1024px)" )
    this.el = document.querySelector('.js-header')
    this.ui = {}
    this.ui.$menuItem = this.el.querySelectorAll('.js-navigation-item')
    this.ui.$menuToggle = this.el.querySelector('.js-navigation-toggle')
    this.ui.$menuToggleText = this.el.querySelector('.js-navigation-text')
    this.ui.$switch = this.el.querySelectorAll('.js-header-lang .lang-item')
    this.isOpen = false
    this.lang = document.documentElement.lang
    if(this.lang == 'fr-FR') {
      this.closeText = "Fermer"
    } else {
      this.closeText = "Close"
    }
  }


  updateHeaderHeight() {
    this.headerHeight = this.el.offsetHeight
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`)
  }

  bindEvents() {
    if(this.mqMin.matches) {
      for (let i = 0; i < this.ui.$menuItem.length; i++) {
        this.ui.$menuItem[i].addEventListener('mouseover', this.onMouseEnter.bind(this))
        this.ui.$menuItem[i].addEventListener('mouseout', this.onMouseOut.bind(this))
      }
    }

    if(this.mqMax.matches) {
      this.ui.$menuToggle.addEventListener('click', this.onClick.bind(this))
    }

    for (let j = 0; j < this.ui.$switch.length; j++) {
      this.ui.$switch[j].addEventListener('click', this.onSwitchLang.bind(this))
    }
  }

  onSwitchLang(e) {
    let target = e.currentTarget
    if(!target.matches('.lang-item')) return 

    for (let j = 0; j < this.ui.$switch.length; j++) {
      this.ui.$switch[j].classList.remove('current-lang')
    }

    if(!target.classList.contains('current-lang')) {
      target.classList.add('current-lang')
    }
  }

  onMouseEnter(e) {
    let target = e.currentTarget
    this.body.classList.add('menu-item-active')
    target.classList.add('item-is-active')
  }
  
  onMouseOut(e) {
    let target = e.currentTarget
    target.classList.remove('item-is-active')
    this.body.classList.remove('menu-item-active')
  }

  onClick(e) {
    const target = e.currentTarget
    if(!target.matches('.js-navigation-toggle')) return

    if(!this.isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    FixScroll.fix()
    this.isOpen = true
    this.body.classList.add('menu-is-open')
    this.ui.$menuToggleText.textContent = this.closeText
  }

  close() {
    FixScroll.unFix()
    this.isOpen = false
    this.body.classList.remove('menu-is-open')
    this.ui.$menuToggleText.textContent = "Menu"
  } 
}

export default Menu
